module.exports = __webpack_public_path__ + "img/bloomberg.svg";